<template>
  <div>
    <v-form v-model="validFormAdicionar" ref="familiaForm">
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <h1 class="text-info font-size-18">
            Cadastrar
            <strong>Família</strong>
          </h1>
        </div>
      </v-flex>
    
      <v-card class="boxInfoDoc" v-show="model.isEmpresaPublica || model.isFuncionarioPublico">
          <v-layout row wrap p-b-10>
        <v-flex>
          <fieldset>
            <legend>
              <strong class="text-primary">Por ser Socio servidor você só está apto para as seguintes famílias:</strong>
            </legend>
            <v-layout row wrap>
                <v-list-tile-content
        v-for="e in listaFamiliaSocios"
        :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
    >
      <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                    {{ e.codGrupo+'.'+e.numFamilia + ' | ' }}
                                </span>
                            </template>
                            {{ e.descFamilia }}
                        </v-tooltip>
				</v-list-tile-content>   
                  <!-- Exceção para exibir Familia 01.46 mesmo que não esteja na lista -->
                  <v-list-tile-content v-if="model.numCgcFornecedor === '020.333.605-47'" :key="'fe_01.46'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  01.46 |
                </span>
              </template>
              Familia 01.46 LOCACAO DE IMOVEIS
            </v-tooltip>
          </v-list-tile-content>           
            </v-layout>
          </fieldset>
        </v-flex>
      </v-layout>
</v-card>
      <v-flex>
        <v-card>

          <v-layout row wrap class="p-t-5 p-b-5">
            <v-flex>
            <v-radio-group
              v-model="tipoFamilia"
              class="mb-0 mt-1"
              row
              persistent-hint
            >
              <v-radio label="Material" value="Material"></v-radio>
              <v-radio label="Serviço" value="Serviço"></v-radio>
              <v-radio label="Ambos" value="Todos"></v-radio>
            </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="p-t-10 p-b-20">
            <v-flex xs12 v-bind:class="{sm9:!modelFamilia.familia,md10:!modelFamilia.familia}">
              <v-autocomplete
                :disabled="isLoadCombo"
                :loading="isLoadCombo"
                hint="Digite pelo menos 3 caracteres para pesquisar."
                :hide-no-data="hideNoData"
                persistent-hint
                clearable
                @click:clear="listaFamilia=[];hideNoData=true;"
                v-model="modelFamilia.familia"
                :items="listaFamilia"
                color="blue-grey lighten-2"
                :label="$t('label.familia')+' *'"
                item-text="descFamilia"
                :return-object="true"
                :search-input.sync="pesquisaFamilia"
                :rules="validacao.campoObrigatorio.concat(validaFamilia)"
                @input="mergeAnexoFamilia(), listaComparacaoCodModeloFamilia()"
                required
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.descFamilia"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.descGrupo"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex
              xs12
              v-bind:class="{'md7':Number(modelFamilia.familia.codGrupo)<10}"
              v-if="modelFamilia.familia"
            >
              <v-text-field
                v-model="modelFamilia.familia.descGrupo"
                :label="$t('label.ramoAtividade')"
                disabled
              ></v-text-field>
            </v-flex>            
            <v-flex
              xs12
              md3
              v-bind:class="{'sm9':Number(modelFamilia.familia.codGrupo)<10,'sm12':Number(modelFamilia.familia.codGrupo)>9}"
              v-if="modelFamilia.familia"
            >
              <v-text-field
                v-model="modelFamilia.familia.tipoItem"
                :label="$t('label.tipoDoItem')"
                disabled
              ></v-text-field>
            </v-flex>
           
            <v-flex
              xs12
              sm9
              md9
              v-if="modelFamilia.familia && Number(modelFamilia.familia.codGrupo)>9"
            >
              <fieldset>
                <legend>{{$t('label.tipoDeQualificacao')}}</legend>
                <v-layout row wrap>
                  <v-flex>
                    <v-radio-group
                      row
                      v-model="modelFamilia.familia.tipoQualificacao"
                      :rules="validacao.campoObrigatorio"
                      required
                    >
                      <v-radio :key="1" label="Fabricante" :value="1"></v-radio>
                      <v-radio :key="2" label="Distribuidor" :value="2"></v-radio>
                      <v-radio :key="3" label="Revendedor" :value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </fieldset>
            </v-flex>
            <v-layout wrap v-if="modelFamilia.familia && exibeCampoAtestado() && familiaExigeAnexo(modelFamilia.familia.codGrupo, modelFamilia.familia.numFamilia)">
              <v-flex xs12 sm9 md10 pt-2>
                <strong class="text-primary" v-if="model.flagEstrangeiro != 1">
                    <strong class="text-primary" v-if="familiaExigeCrea(modelFamilia.familia.codGrupo, modelFamilia.familia.numFamilia)">
                  CERTIDÃO DE ACERVO TÉCNICO COM ATESTADO
                  </strong>
                   <div v-else>
                  <strong class="text-primary" v-if="this.model.tipoCertificado != 3">
                  ATESTADO DE CAPACIDADE TECNICA
                  </strong>                 
                </div>
                </strong>
                <div v-else>
                  <strong class="text-primary">
                   ATESTADO DE CAPACIDADE TÉCNICA COM TRADUÇÃO JURAMENTADA
                  </strong>
                  <span class="text-primary">
                    (OU DOCUMENTO EQUIVALENTE*)
                  </span>
                </div>
              </v-flex>

              <v-flex inputIcon v-show="!modelFamilia.anexoFamiliaVm.file.novoUpload">
                <v-text-field
                  :value="isLink(modelFamilia.anexoFamiliaVm.arquivoUpload) ? modelFamilia.anexoFamiliaVm.arquivoUpload : subStrUpload(modelFamilia.anexoFamiliaVm.arquivoUpload,modelFamilia.anexoFamiliaVm.nomDocumento)"
                  :label="$t('label.anexaDocumento')+ ' *'"
                  clearable
                  append-icon="get_app"
                  readonly
                  :class="{'link-anexo-familia': isLink(modelFamilia.anexoFamiliaVm.arquivoUpload)}"
                  @click="abrirLink(modelFamilia.anexoFamiliaVm.arquivoUpload)"
                  @click:append="baixarArquivo(modelFamilia.anexoFamiliaVm.file.arquivoUpload)"
                  @click:clear="modelFamilia.anexoFamiliaVm.file.novoUpload = true;modelFamilia.anexoFamiliaVm.file.arquivoUpload = null;"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="text-primary" v-if="model.flagEstrangeiro == 1 && modelFamilia.familia">
                *<sub>Conforme Lei nº 9.433/2005.</sub>
              </v-flex>
              <v-flex v-if="(modelFamilia.anexoFamiliaVm.file.novoUpload && this.model.tipoCertificado != 3 && Number(modelFamilia.familia.codGrupo)<10) 
              || (this.model.tipoCertificado == 3 && model.flagEstrangeiro == 1)
              ">
                <uploadFile
                  tamanhoMaximo="20MB"
                  required               
                  :label="$t('label.anexaDocumento')+ ' *'"
                  v-model="modelFamilia.anexoFamiliaVm.file.arquivoUpload"
                  accept=".pdf, .PDF"
                />
              </v-flex>
             
            </v-layout>
            <v-flex xs12 sm3 md2 my-auto>
              <v-btn @click="salvar()" large color="primary" dark class="mb-2">Adicionar</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-form>
    <v-form v-model="validFormFamilias" ref="boxFamilias">
      <div class="p-t-30 boxFamilias">
        <v-layout
          row
          wrap
          class="p-t-10 p-b-20"
          v-for="(item, index) in model.familiaSolicitacao"
          :key="item.codGrupo+''+item.familiaAssociada.codFamilia"
          
        >
        
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar light :class="{'item-reprovado':verificaErro(item)}">
                <v-toolbar-title>
                  <strong>{{item.familiaAssociada.codFamilia}}</strong>
                  - {{item.familiaAssociada.descFamilia}}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn v-if="!$verificaPerfilCadastrador() || RetornaInfoFamilia(item.codGrupo,item.numFamilia)" icon @click="deleteItem(item,index)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>

                <v-btn icon @click="openBox(item)">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>

              <v-layout
                row
                wrap
                class="p-t-10 p-b-20"
                v-show="isShow[item.$id+'_'+item.codGrupo+'_'+item.familiaAssociada.codFamilia]"
              >
                <v-flex>
                  <v-card>
                    <v-layout row wrap class="p-t-10 p-b-20">
                      <v-flex xs12 v-bind:class="{'md9':Number(item.codGrupo)<10}">
                        <v-text-field
                          v-model="item.familiaAssociada.descGrupo"
                          :label="$t('label.ramoAtividade')"
                          disabled
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        xs12
                        md3
                        v-bind:class="{'sm12':Number(item.codGrupo)<10,'sm12':Number(item.codGrupo)>9}"
                      >
                        <v-text-field
                          v-model="item.familiaAssociada.tipoItem"
                          :label="$t('label.tipoDoItem')"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md9 v-if="Number(item.codGrupo)>9">
                        <fieldset>
                          <legend>{{$t('label.tipoDeQualificacao')}}</legend>
                          <v-layout row wrap>
                            <v-flex>
                              <v-radio-group row v-model="item.tipoQualificacao">
                                <v-radio :key="1" label="Fabricante" :value="1" @change="updateItem(item)"></v-radio>
                                <v-radio :key="2" label="Revendedor" :value="2" @change="updateItem(item)"></v-radio>
                                <v-radio :key="3" label="Distribuidor" :value="3" @change="updateItem(item)"></v-radio>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>
                        </fieldset>
                      </v-flex>
                      <v-layout wrap v-if="exibeCampoAtestado() && familiaExigeAnexo(item.codGrupo, item.numFamilia)">
                        <v-flex xs12 v-if="model.tipoCertificado != 3">
                            <strong class="text-primary" v-if="model.flagEstrangeiro != 1 ">
                             <strong class="text-primary" v-if="familiaExigeCrea(item.codGrupo, item.numFamilia)">
                              CERTIDÃO DE ACERVO TÉCNICO COM ATESTADO
                                </strong>                              
                         <strong v-else class="text-primary">
                                ATESTADO DE CAPACIDADE TECNICA
                                </strong>    
                                </strong>  
                            <div v-else>
                              <strong class="text-primary">
                                 ATESTADO DE CAPACIDADE TÉCNICA COM TRADUÇÃO JURAMENTADA
                              </strong>
                              <span class="text-primary">
                                (OU DOCUMENTO EQUIVALENTE )
                              </span>
                            </div>
                        </v-flex>
                        <v-flex xs12 inputIcon v-show="item.anexoFamilia && item.anexoFamilia.file && !item.anexoFamilia.file.novoUpload">
                          <v-text-field
                            :value="isLink(arquivoAnexoFamilia(item.anexoFamilia)) ? arquivoAnexoFamilia(item.anexoFamilia) : subStrUpload(arquivoAnexoFamilia(item.anexoFamilia))"
                            :label="$t('label.anexaDocumento')+ ' *'"
                            append-icon="get_app"
                            clearable
                            :class="{'link-anexo-familia': isLink(arquivoAnexoFamilia(item.anexoFamilia))}"
                            @click="abrirLink(arquivoAnexoFamilia(item.anexoFamilia))"
                            @click:clear="item.anexoFamilia.file.novoUpload = true;item.anexoFamilia.file.arquivoUpload = null;"
                            @click:append="baixarArquivo(arquivoAnexoFamilia(item.anexoFamilia))"                             
                          ></v-text-field>
                       
                        </v-flex>
                       
                        <v-flex xs12 v-if="item.anexoFamilia && item.anexoFamilia.file && item.anexoFamilia.file.novoUpload && model.tipoCertificado != 3">
                          <uploadFile
                            tamanhoMaximo="20MB"
                            required
                            :label="$t('label.anexaDocumento')+ ' *'"
                            v-model="item.anexoFamilia.file.arquivoUpload"
                            accept=".pdf, .PDF"
                            @input="salvarAtualizacao(item)" 
                          />
                        </v-flex>
                        <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                          *<sub>Conforme Lei nº 9.433/2005.</sub>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>    
      <v-dialog v-model="dialogoVisivel" max-width="400"> <!-- Defina a largura máxima do dialog -->
    <v-card>
        <v-card-title>Prezado Fornecedor,</v-card-title>
        <v-card-text>
          <div>            
            <p>Os agentes públicos ficam, conforme Lei Estadual Nº 14.634/2023 impedidos de contratar direta ou indiretamente com a Administração Pública por vedação constitucional.</p><br>
            <p>Art. 70 - Na forma do § 1º do art. 9º da Lei Federal nº 14.133, de 01 de abril de 2021, não poderá participar, direta ou indiretamente, da licitação ou da execução do contrato, agente público de órgão ou entidade licitante ou contratante.</p><br>
            <p>§ 1º - Aplica-se a vedação do caput deste artigo aos demais agentes públicos, conforme o conceito constante do inciso V do art. 6º da Lei Federal nº 14.133, de 01 de abril de 2021, impedidos de contratar com a Administração Pública por vedação constitucional ou legal.</p><br>
            <p>§ 2º - Não se inclui na vedação do caput desde artigo a prestação de serviços em caráter eventual, de consultoria técnica, treinamento e aperfeiçoamento, bem como a participação em comissões examinadoras de concursos, no âmbito da Administração Pública.</p><br>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn small color="primary" dark class="mb-2" @click="fecharDialogo">OK</v-btn> <!-- Defina o tamanho pequeno do botão -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-form>
  </div>


</template>

<script>
import familiaService from "../../services/familiaService";
import fornecedorService from "../../services/fornecedorService";
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "familia",
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    erroFamilia: Object,
    getListaDocsQualificacaoTecnica:Function,
    hasError: Boolean,
  },
  mixins: [util],
  watch: { //Propriedades assistidas
    pesquisaFamilia(newValor, oldValor) {
      //pesquisar familia
      this.pesquisaCombo(
        newValor,
        oldValor,
        "listaFamilia",
        eval("this.listaFamilia"),
        "model.familia",
        this.getFamilia,
        2
      );
    },
     CarregarFamiliaNova(newValor, oldValor) {
      //pesquisar familia
      model.familiaSolicitacao
      
    },
    
  },
  data() {//Declaracao de variaveis
    return {
      resultado: [],
      retornaResult: null,
      comparacaoCodModeloFamilia: [],
      listaCodFamiliaComCrea: [],
      exibirMsnCreaEmAnexarDocumento: null,// valor booleano
      tipoFamilia: "Todos",
      validFormAdicionar:true,
      validFormFamilias:true,
      dialogoVisivel: false,
      isShow: {},
      pesquisaFamilia: null,
       isRetornoCadastrador: false,
      modelFamilia: {},
      isLoadCombo: false,      
      listaFamilia: [],
      listaFamiliaSocios: [], // Inicializa como array vazio
      listaFamiliaNova: [],
      isCadastradorFamilia : null,
      cadastrouSocioServidor : false,
      validaFamilia: [
        v =>
          (v && this.validaFamiliaDuplicidade(v)) ||
          this.$t("messages.validacao.familiaJaAssociada")
      ]
       
    };
    
  },
  created(){
    this.$store.commit("setAba", {abaAtiva: "tab-familia"});
    // Carrega lista de famílias normalmente
    familiaService.getListaFamiliaCatalagoMat(" ").then(response => {
      response.data.filter(item => {
        this.listaFamiliaSocios.push(item);
      });
    });

    // ============================================================
    // NOVA REGRA: ouvir eventos de alteração do Contrato Social
    // Perfis aceitos: fornecedor, validador, validador master, CADASTRADOR
    // ============================================================
    var self = this;

    this.$root.$on("contratoSocialAlterado", function(payload) {
   
      if (!payload || !payload.alterado) {
       
        return;
      }

      // Perfis permitidos
      var permitido =
        payload.perfil === "fornecedor" ||
        payload.perfil === "validador" ||
        payload.perfil === "cadastrador";

      if (!permitido) {    
        return;
      }

      // Marcar para reanálise
      self.familiasResetadasParaReanalise = true;
      self.motivoReanalise = "Contrato Social alterado";
      self.timestampReanalise = payload.timestamp;

      console.log("DEBUG familia.vue: famílias marcadas para reanálise:", {
        motivo: self.motivoReanalise,
        timestamp: self.timestampReanalise
      });
    });
  },
  beforeDestroy() {
    console.log("DEBUG familia.vue: removendo listener contratoSocialAlterado");
    this.$root.$off("contratoSocialAlterado");
  },

  mounted() {
    this.listaComparacaoCodModeloFamilia();
    this.ValidaItemNovo();
    //this.carreganovaFamilia();
   // console.log(this.listaFamiliaNova);
  },

  methods: {//Declaracao de todos os metodos
    exibirDialogo() {
      this.dialogoVisivel = true;
    },
    salvarAtualizacao(item) {
  // Verifica se já existe um registro com mesmo codGrupo e numFamilia
  const duplicataIndex = this.model.familiaSolicitacao.findIndex(f => 
    f.codGrupo === item.codGrupo && 
    f.numFamilia === item.numFamilia && 
    f !== item
  );

  if (duplicataIndex !== -1) {
    this.$delete(this.model.familiaSolicitacao, duplicataIndex);
  }

  // Monta o objeto FamiliaSolicitacaoVm replicando a estrutura do salvar()
  const familiaSolicitacaoVm = {
    Familia: {
      IdFornecSolicitacao: this.model.idFornecSolicitacao,
      NumCgcFornecedor: this.model.numCgcFornecedor,
      CodGrupo: item.codGrupo,
      NumFamilia: item.numFamilia,
      TipoQualificacao: item.tipoQualificacao || (Number(item.codGrupo) <= 9 ? 4 : null),
      FamiliaAssociada: null
    },
    anexoFamiliaVm: {
      anexoFamilia: {
        arquivoUpload: null, // Inicialmente null, como no criarModelFamilia
        codDocumento: 109,
        idFamiliaSolicitacao: item.idFamiliaFornec || null
      },
      file: {
        arquivoUpload: item.anexoFamilia.file.arquivoUpload, // Mantém o objeto File como está
        novoUpload: item.anexoFamilia.file.novoUpload
      }
    }
  };



  // Chama o serviço de salvar
  familiaService.salvar(familiaSolicitacaoVm).then((response) => {
  // Normaliza os dados antes de aplicar no model
        const dadosNormalizados = response.data.map(item => {
          // Garante que anexoFamilia exista
          item.anexoFamilia = item.anexoFamilia || {};

          // Garante que anexoFamilia.file exista e tenha as propriedades padrão
          item.anexoFamilia.file = {
            arquivoUpload: null,
            novoUpload: false,
            ...(item.anexoFamilia.file || {})
          };

          return item;
        });

        this.model.familiaSolicitacao = dadosNormalizados;

        this.getListaDocsQualificacaoTecnica();
        this.$toasted.success(this.$t("messages.cadastro.sucesso"));
      }).catch(error => {
        this.$toasted.error("Erro ao atualizar o anexo");
        console.error("Erro:", error);
      });
 
},
    fecharDialogo() {
      this.dialogoVisivel = false;
      this.modelFamilia.familia = null;
    },
  carreganovaFamilia(){

     const ifExiste = this.model.familiaSolicitacao.filter(item => {
        return item.familiaAssociada.codFamilia === v.codFamilia;
      });

      this.model.familiaSolicitacao.filter(function(familia, index) {
       let objNovo = { codgrupo : familia.codGrupo, numFamilia : familia.numFamilia, exibeBotaoDeltar : false };
       this.listaFamiliaNova.push(objNovo);
      // let    ValidaItemNovo(x.item)
      } );    

  },

  RetornaInfoFamilia(codGrupoP, numFamiliaP){
 
    let itemRetorno = [];     
      itemRetorno = this.resultado.filter(item => {       
        return item.codGrupo == codGrupoP && item.numFamilia == numFamiliaP;
      });      
         
      if( itemRetorno.length > 0 ){
        return itemRetorno[0].exibeBotaoDeltar;
      }
      else
      {
        return true;
      }
  },

  listaComparacaoCodModeloFamilia(item){
      //Listas com os  codigos das Familias para comparação, e ver se tem ou não Crea.
      //Essa lista aqui são familas que são Exigidos: "Crea-cons regional de eng e agronomia e Certidão de acervo técnico com atestado"
      //Famílias de serviços terceirizados também exigem anexo e não entram na lista geral.
      this.listaCodFamiliaComCrea = [
        //Codigo das Familias familias estão em modelFamilia.familia.codFamilia, lista para comparação:
        '02.04','02.11','02.14','02.27','02.39','02.48','03.01','03.04','03.19','03.20','03.21','03.31','03.34','04.02','04.04',
        '04.07','04.08','04.09','04.11','04.12','04.13','04.14','04.16','04.17','04.18','04.19','04.20','04.21','04.22','04.23',
        '04.26','04.27','04.28','04.30','04.32','04.35','04.37','04.38','04.39','04.40','04.41','04.42','04.43','04.49','04.51',
        '04.52','04.56','04.68','06.01','06.02','06.03','06.04','06.05','06.06','06.09','06.10','06.11','06.12','06.13','06.14',
        '06.15','06.16','06.17','06.18','06.19','06.20','06.21','06.22','06.23','06.24','06.25','06.26','06.27','06.28','06.29',
        '06.30','06.31','06.32','06.33','06.34','06.35','06.36','06.38','06.39','06.40','06.41','06.42','06.43','06.44',
        '06.45','06.46','06.47','06.48','06.49','06.50','06.51','06.52','06.53','06.54','06.55','06.56','06.57','06.58','06.59',
        '06.60','06.61','06.62','06.63','06.64','06.65','06.66','06.68','06.69','06.70','06.71','06.72','07.01','07.02','07.03',
        '07.04','07.05','07.06','07.07','07.08','07.09','07.10','07.11','07.12','07.13','07.14','07.15','07.16','07.17','07.18',
        '07.19','07.20','07.21','07.23','07.24','07.25','07.26','07.27','07.28','07.29','07.30','07.31','07.32','07.33','07.34',
        '07.35','07.36','08.07','08.08','08.09','08.10','08.12','08.14','08.15','08.16','08.17','08.18','08.19','08.20','08.21',
        '08.22','08.24','08.25','08.26','08.27','08.28','08.29','08.30','08.31','08.33','08.34','08.35','08.36','08.37','08.38',
        '08.39','08.40','08.41','08.42','08.43','08.45','08.46','08.47','08.48','08.49','08.51','08.52','08.53','08.54','08.57',
        '08.58','08.59','08.60','08.61'
      ];

      const listaFamiliasServicosTerceirizados = [
        '01.98', '03.16', '03.25', '03.29', '03.30', '04.56'
      ];

      this.comparacaoCodModeloFamilia = this.listaCodFamiliaComCrea.concat(listaFamiliasServicosTerceirizados);
    },

    comparacaoExibirMsnCreaEmAnexarDocumento(){
      for (let index = 0; index < this.comparacaoCodModeloFamilia.length; index++ ){
        if (this.comparacaoCodModeloFamilia[index] === this.modelFamilia.familia.codFamilia){
          return this.exibirMsnCreaEmAnexarDocumento = true ;

        }else this.exibirMsnCreaEmAnexarDocumento = false;
      }
    },
    getSocio(){

          this.model.fornecedoresHabilitacaoJuridica.filter(item => {    
           
          if(item.isFuncionarioPublico) {
            this.cadastrouSocioServidor = true;
          }
                
        });
      },
    getFamilia(valor) {
      //resgatar familia
      this.isLoadCombo = true;
      let descricao = valor;

    
      
      familiaService.getListaFamiliaCatalagoMat(descricao).then(response => { /*resposta do servico*/
        var familiaFiltrada = [];
        if(this.tipoFamilia !== "Todos"){
          response.data.filter(item => {
            if(item.tipoItem == this.tipoFamilia ){            
              familiaFiltrada.push(item);
            }  

          });
          
          response.data = familiaFiltrada;

        }
        this.hideNoData = false;
        this.listaFamilia = [];
        var array = [];
        var cabecalho = { header: null };
        var separador = { divider: false };

        response.data.filter(item => {
          if (item.descGrupo !== cabecalho.header) {
             
            if (separador.divider) {
              array.push(separador);
            }
            cabecalho = { header: item.descGrupo };
            array.push(cabecalho);
          }
          item.descFamilia = item.codFamilia + " - " + item.descFamilia;
          
          array.push(item);

          separador = { divider: true };
        });
       
        this.listaFamilia = array;
        this.isLoadCombo = false;
      })
    },
    ValidaItemNovo : function()
    { 
      if(this.model.familiaSolicitacao){
          this.model.familiaSolicitacao.forEach((familia, i) => {
            familiaService.validaFamiliaCadastrador(familia.codGrupo,familia.numFamilia,familia.numCgcFornecedor).then((result) =>{    
             let objNovo = { codGrupo : familia.codGrupo, numFamilia : familia.numFamilia, exibeBotaoDeltar : result.data };
            this.resultado.push(objNovo);             
            });       
          });
      } 
      
    },      
   
    salvar() {
      this.erroFamilia.erro = false;

      if (this.$refs.familiaForm.validate()) {
        if (this.modelFamilia.familia.codGrupo <= 9) {
          this.modelFamilia.familia.tipoQualificacao = 4;
        }
        this.modelFamilia.familia.idFornecSolicitacao = this.model.idFornecSolicitacao;
        this.modelFamilia.familia.numCgcFornecedor = this.model.numCgcFornecedor;

        this.getSocio();

        // Usando let ao invés de const
        let possuiSocioServidor =
          this.model.fornecedoresHabilitacaoJuridica.some(item => item.isFuncionarioPublico) ||
          this.model.isFuncionarioPublico;

        if (!this.model.isEmpresaPublica && possuiSocioServidor) {
          if (
            this.modelFamilia.familia.codFamilia === "01.46" &&
            this.model.numCgcFornecedor === "020.333.605-47"
          ) {
            // Exceção para a família "01.46"
          } else if (this.modelFamilia.familia.flagSocioServidor !== 1) {
            this.exibirDialogo();
            return;
          }

          const familiaInvalida = this.model.familiaSolicitacao.some(
            (f) => f.familiaAssociada.flagSocioServidor !== 1
          );

          if (familiaInvalida) {
            this.setErro(
              "Existem famílias inválidas na solicitação. Por favor, remova-as antes de continuar.",
              "tab-familias"
            );
            return;
          }
        }
     
        familiaService.salvar(this.modelFamilia).then((response) => {
          this.$refs.familiaForm.resetValidation();
          this.model.familiaSolicitacao = response.data;

          const objNovo = {
            codgrupo: this.modelFamilia.codGrupo,
            numFamilia: this.modelFamilia.numFamilia,
            exibeBotaoDeltar: true,
          };
          this.listaFamiliaNova.push(objNovo);

          this.listaFamilia = [];
          this.modelFamilia = this.criarModelFamilia();
          this.montaAnexoFamilia();
          this.hideNoData = true;
          this.getListaDocsQualificacaoTecnica();

          this.$toasted.success(this.$t("messages.cadastro.sucesso"));
        });
      }
    },

    openBox(item) {
      //abrir o detalhamento da familia
      const flag = this.isShow[
        item.$id + "_" + item.codGrupo + "_" + item.familiaAssociada.codFamilia
      ];
      this.$set(
        this.isShow,
        item.$id + "_" + item.codGrupo + "_" + item.familiaAssociada.codFamilia,
        !flag
      );
    },

    deleteItem(item,index) {
        //deletar a familia
        
        familiaService.delete(item).then(()=>{
          //Remove do array de familias
          this.$delete(this.model.familiaSolicitacao,index);
          this.getListaDocsQualificacaoTecnica();
           
        });    

    },
   
    updateItem(item) {
      //atualizar aa famulia
      familiaService.atualizar(item).then();
           this.getListaDocsQualificacaoTecnica();
    },

    validaFamiliaDuplicidade(v) {
      //validar se ja nao existe a mesma familia cadastrada
      const ifExiste = this.model.familiaSolicitacao.filter(item => {
        return item.familiaAssociada.codFamilia === v.codFamilia;
      });
      if (ifExiste.length) return false;
      else return true;
    },
    criarModelFamilia(){
      return {
        anexoFamiliaVm: {
          anexoFamilia:{
            arquivoUpload: null,
            codDocumento: 109
          },
          file: {
            arquivoUpload: null,
            novoUpload: true
          }
        }
      };
    },
    montaAnexoFamilia(){
      this.model.familiaSolicitacao.filter(item => {
        let anexo =
        {
          anexoFamiliaSituacao: item.anexoFamilia ? item.anexoFamilia.anexoFamiliaSituacao : null,
          arquivoUpload: item.anexoFamilia ? item.anexoFamilia.arquivoUpload : null,
          codDocumento: 109,
          dtRejeicao: item.anexoFamilia ? item.anexoFamilia.dtRejeicao : null,
          idFamiliaSolicitacao: item.anexoFamilia ? item.anexoFamilia.idFamiliaSolicitacao : item.idFamiliaFornec,
          idMotivoIndeferimentoArquivo: item.anexoFamilia ? item.anexoFamilia.idMotivoIndeferimentoArquivo : null,
          file: {
            arquivoUpload: null,
            novoUpload: item.anexoFamilia && item.anexoFamilia.arquivoUpload ? false : true
          }
        }
        item.anexoFamilia = (item.anexoFamilia) ? {...item.anexoFamilia,...anexo} : anexo;
      });
    },

    mergeAnexoFamilia(){
      this.modelFamilia =  {  ...this.criarModelFamilia(), ...this.modelFamilia};
      this.comparacaoExibirMsnCreaEmAnexarDocumento();
    },

    baixarArquivo(arquivo) {
      //baixar o documento
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g,"");
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    abrirLink(arquivo) {
      if (this.isLink(arquivo)) {
        window.open(arquivo, "_blank");
      }
    },
    arquivoAnexoFamilia(anexoFamilia){
      if(anexoFamilia.file.novoUpload){
        if(anexoFamilia.file.arquivoUpload != null){
          return anexoFamilia.file.arquivoUpload.filename;
        }
        return null;
      }else{
        return anexoFamilia.arquivoUpload;
      }
    },

    exibeCampoAtestado() {
      //No ticket 157260 pediu para que os estrangeiros registrassem o Atestado de capacidade técnica
     
      return (this.model.tipoCertificado !== 3 || this.model.flagEstrangeiro == 1) ; 
    
    },
    normalizaCodigoFamilia(codGrupo, numFamilia) {
      const grupo = String(codGrupo || '').padStart(2, '0');
      const familia = String(numFamilia || '').padStart(2, '0');
      return `${grupo}.${familia}`;
    },
    familiaExigeAnexo(codGrupo, numFamilia) {
      if (!codGrupo || !numFamilia) {
        return false;
      }

      return Number(codGrupo) < 10 &&
        (this.model.tipoCertificado !== 3 || this.model.flagEstrangeiro == 1);
    },
    familiaExigeCrea(codGrupo, numFamilia) {
      if (!codGrupo || !numFamilia) {
        return false;
      }

      const codigoFamilia = this.normalizaCodigoFamilia(codGrupo, numFamilia);
      return Array.isArray(this.listaCodFamiliaComCrea) &&
        this.listaCodFamiliaComCrea.includes(codigoFamilia);
    },

     isAnexoValido(anexo){
      if (anexo && anexo.arquivoUpload === "Não Encontrado"){
        return true;
      } 
    },


    verificaErro(item){
      
      if(this.hasError){
        return (((item.anexoFamilia.file.novoUpload === true 
               && item.anexoFamilia.file.arquivoUpload == null) || 
                (item.anexoFamilia.file.novoUpload === false 
                  && item.anexoFamilia.arquivoUpload === "Não Encontrado")) && Number(item.codGrupo) < 10);
      }
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.link-anexo-familia {
  cursor: pointer;
}

.link-anexo-familia .v-text-field__slot input {
  color: #10618b;
  text-decoration: underline;
}

.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}
</style>
